import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { OnlinePaymentTransactionStatusModel } from 'src/app/model/OnlinePaymentTransactionStatusModel';

@Component({
  selector: 'app-secure-assign-moderation-modal',
  templateUrl: './assign-moderation-modal.component.html',
  styleUrls: ['./assign-moderation-modal.component.scss']
})
export class AssignModerationModalComponent implements OnInit {
  obj: OnlinePaymentTransactionStatusModel;
  isSubmitDisabled: boolean;
  assginModerationCasesForm: FormGroup = new FormGroup({});
  
  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void { 
    this.assginModerationCasesForm = new FormGroup({
      assignCount: new FormControl(null, [Validators.required, Validators.min(2)])
    });
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

  onSubmit() {
    if (this.assginModerationCasesForm.valid) {
      return this.modalCtrl.dismiss(+this.assginModerationCasesForm.value.assignCount, 'submit');
    }
    else {
      this.isSubmitDisabled = false;
    }
  }
}
